/**
 * @flow
 * @relayHash 6695fcb9379c3018c0280b15063b9f69
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateBrandInput = {
  clientMutationId?: ?string,
  id: string,
  header?: ?string,
  logo_handle?: ?string,
  logo_size?: ?number,
  logo_url?: ?string,
  logo_mimetype?: ?string,
};
export type Brand_Form_updateBrandMutationVariables = {|
  input: UpdateBrandInput
|};
export type Brand_Form_updateBrandMutationResponse = {|
  +updateBrand: ?{|
    +brand: ?{|
      +id: string,
      +header: ?string,
    |}
  |}
|};
export type Brand_Form_updateBrandMutation = {|
  variables: Brand_Form_updateBrandMutationVariables,
  response: Brand_Form_updateBrandMutationResponse,
|};
*/


/*
mutation Brand_Form_updateBrandMutation(
  $input: UpdateBrandInput!
) {
  updateBrand(input: $input) {
    brand {
      id
      header
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateBrandInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateBrand",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateBrandInput!"
      }
    ],
    "concreteType": "UpdateBrandPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "brand",
        "storageKey": null,
        "args": null,
        "concreteType": "Brand",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "id",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "header",
            "args": null,
            "storageKey": null
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "Brand_Form_updateBrandMutation",
  "id": null,
  "text": "mutation Brand_Form_updateBrandMutation(\n  $input: UpdateBrandInput!\n) {\n  updateBrand(input: $input) {\n    brand {\n      id\n      header\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "Brand_Form_updateBrandMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v1
  },
  "operation": {
    "kind": "Operation",
    "name": "Brand_Form_updateBrandMutation",
    "argumentDefinitions": v0,
    "selections": v1
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '982748ed41746ca29b27bc549f806503';
module.exports = node;



// WEBPACK FOOTER //
// ./webpack/components/Document/Form/__generated__/Brand_Form_updateBrandMutation.graphql.js